(() => {
  const header = document.querySelector("[data-header]");

  if (!header) {
    return;
  }

  const menuButton = header.querySelector("[data-header-menu]");
  const drawer = header.querySelector("[data-header-drawer]");
  const panel = drawer.querySelector(".header__drawer-panel");
  const closeButtons = header.querySelectorAll("[data-header-drawer-close]");
  const drawerLinks = drawer.querySelectorAll(".header__drawer-link, .header__drawer-sublink");
  const submenuToggles = drawer.querySelectorAll("[data-drawer-submenu-toggle]");
  const desktopItems = header.querySelectorAll(".header__nav-item--has-children");
  const mobileQuery = window.matchMedia("(max-width: 1024px)");

  const isMobile = () => mobileQuery.matches;

  function openMenu() {
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-menu-open");
    menuButton.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      header.classList.add("header--menu-open");
    });
  }

  function closeMenu() {
    if (!header.classList.contains("header--menu-open")) {
      return;
    }

    header.classList.remove("header--menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    closeAllDrawerSubmenus();

    panel.addEventListener("transitionend", onCloseEnd);
  }

  function onCloseEnd(event) {
    if (event.target !== panel || event.propertyName !== "transform") {
      return;
    }

    panel.removeEventListener("transitionend", onCloseEnd);
    document.body.classList.remove("is-menu-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function expandDrawerSubmenu(item, toggle, collapse) {
    collapse.hidden = false;
    item.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
  }

  function collapseDrawerSubmenu(item, toggle, collapse) {
    if (!item.classList.contains("is-open")) return;

    item.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");

    collapse.addEventListener("transitionend", function onClose(event) {
      if (event.propertyName !== "grid-template-rows") return;

      if (!item.classList.contains("is-open")) {
        collapse.hidden = true;
      }

      collapse.removeEventListener("transitionend", onClose);
    });
  }

  function closeAllDrawerSubmenus() {
    submenuToggles.forEach((toggle) => {
      const item = toggle.closest(".header__drawer-item--has-children");
      const submenuId = toggle.getAttribute("aria-controls");
      const collapse = submenuId ? document.getElementById(submenuId) : null;
      if (!item || !collapse) return;
      collapseDrawerSubmenu(item, toggle, collapse);
    });
  }

  function toggleDrawerSubmenu(toggle) {
    const item = toggle.closest(".header__drawer-item--has-children");
    const submenuId = toggle.getAttribute("aria-controls");
    const collapse = submenuId ? document.getElementById(submenuId) : null;
    if (!item || !collapse) return;

    if (item.classList.contains("is-open")) {
      collapseDrawerSubmenu(item, toggle, collapse);
      return;
    }

    submenuToggles.forEach((other) => {
      if (other === toggle) return;
      const otherItem = other.closest(".header__drawer-item--has-children");
      const otherId = other.getAttribute("aria-controls");
      const otherCollapse = otherId ? document.getElementById(otherId) : null;
      if (!otherItem || !otherCollapse) return;
      collapseDrawerSubmenu(otherItem, other, otherCollapse);
    });

    expandDrawerSubmenu(item, toggle, collapse);
  }

  function closeDesktopDropdowns(except) {
    desktopItems.forEach((item) => {
      if (item === except) return;
      const link = item.querySelector(".header__nav-link");
      item.classList.remove("is-open");
      if (link) link.setAttribute("aria-expanded", "false");
    });
  }

  menuButton.addEventListener("click", openMenu);

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeMenu);
  });

  drawerLinks.forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      toggleDrawerSubmenu(toggle);
    });
  });

  desktopItems.forEach((item) => {
    const link = item.querySelector(".header__nav-link");
    if (!link) return;

    link.addEventListener("click", (event) => {
      if (isMobile()) return;
      if (!item.querySelector(".header__dropdown")) return;

      event.preventDefault();
      const willOpen = !item.classList.contains("is-open");
      closeDesktopDropdowns(item);
      item.classList.toggle("is-open", willOpen);
      link.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
  });

  document.addEventListener("click", (event) => {
    if (isMobile()) return;
    if (header.contains(event.target) && event.target.closest(".header__nav-item--has-children")) {
      return;
    }
    closeDesktopDropdowns();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
      closeDesktopDropdowns();
    }
  });

  function onViewportChange() {
    if (!isMobile()) {
      closeMenu();
    } else {
      closeDesktopDropdowns();
    }
  }

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", onViewportChange);
  } else if (typeof mobileQuery.addListener === "function") {
    mobileQuery.addListener(onViewportChange);
  }
})();
